import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';
import Eyebrow from '../components/Eyebrow';
import Chip from '../components/Chip';

const formatDate = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' });
};
const formatTime = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
};

// Top-of-document header. Eyebrow + meeting title + meta line + status chips.
// Deal stage and sentiment chips are internal-only — the prospect-facing
// shared variant strips them.
const MeetingHeaderSection = ({ report }) => {
  const { meeting } = report;
  const isShared = report.variant === 'shared';
  const metaParts = [
    formatDate(meeting.dateISO),
    formatTime(meeting.dateISO),
    meeting.durationMinutes ? `${meeting.durationMinutes} min` : null,
    meeting.type,
  ].filter(Boolean);

  return (
    <View>
      <Eyebrow>{isShared ? 'Meeting Recap' : 'Meeting Review'}</Eyebrow>
      <Text style={[type.h1, { color: colors.ink, marginTop: 4 }]}>{meeting.title}</Text>
      <Text style={[type.bodyMed, { color: colors.inkSoft, marginTop: 4 }]}>
        {metaParts.join(' · ')}
      </Text>
      {!isShared && (
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: space.md }}>
          {meeting.dealStage && <Chip>{meeting.dealStage} stage</Chip>}
          {meeting.sentiment && (
            <Chip variant={meeting.sentiment === 'Positive' ? 'success' : meeting.sentiment === 'Negative' ? 'danger' : 'warning'}>
              {meeting.sentiment}
            </Chip>
          )}
        </View>
      )}
    </View>
  );
};

export default MeetingHeaderSection;
